<template>
    <div v-if="hasActivePage">
      <template v-for="component in activePage.components">
        <div :key="component._key" v-if="component._type === 'newHero'">
          <NewHeroHome :component="component" />
        </div>
        <div :key="component._key" v-if="component._type === 'pricing'">
          <NewSignUp :component="component" />
        </div>
        <div :key="component._key" v-if="component._type === 'newTestimonials'">
          <NewTestimonials :component="component" />
        </div>
        <div :key="component._key" v-if="component._type === 'retirement'">
          <Retirement :component="component" />
        </div>
        <div :key="component._key" v-if="component._type === 'htmlOnly'">
          <HtmlOnly :component="component" />
        </div>
      </template>
      <button id="challenge-checkout" :style="{ display: 'none'}" @click="checkout" >Supp</button>
    </div>
    <div v-else>
        <NotFound />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import isEmpty from 'lodash/isEmpty'
import store from '../store/index'
import NotFound from './NotFound'

import HtmlOnly from '@components/html-only/html-only.vue'
import NewTestimonials from '../components/testimonials/newTestimonials.vue'
import NewSignUp from '@components/signUp/new-sign-up.vue'
import NewHeroHome from '../components/hero/new-hero-home.vue'
import Retirement from '@components/retirement/retirement.vue'

export default {
  components: {
    NotFound,
    HtmlOnly,
    NewTestimonials,
    NewSignUp,
    Retirement,
    NewHeroHome
  },
  data () {
    return {
      isLoginOpen: false,
      isCardOpen: false
    }
  },
  name: 'Page',
  computed: {
    ...mapState(['activePage', 'user', 'settings']),
    hasActivePage () {
      return !isEmpty(this.activePage)
    }
  },
  created () {
    if (this.hasActivePage && window.ga) {
      window.ga('set', 'page', `/${this.activePage.slug.current}`)
      window.ga('send', 'pageview')
    }
  },
  beforeRouteEnter (to, from, next) {
    if (store.state.pages.length === 0) { // if state not ready then watch it
      const watcher = store.watch(function (state) { return state.challenges }, (pages) => { // when pages value ready
        watcher() // stop watching
        const foundPage = store.getters.pages.find(page => {
          return '/' + page.slug.current === to.path
        })

        if (foundPage) {
          store.commit('setActivePage', foundPage)
          store.commit('setActiveChallengePage', foundPage)
        }
        next()
      })
    } else if (store.state.pages.length > 0) {
      const foundPage = store.getters.pages.find(page => {
        return '/' + page.slug.current === to.path
      })

      if (foundPage) {
        store.commit('setActivePage', foundPage)
        store.commit('setActiveChallengePage', foundPage)
      }
      next()
    } else next('/')
  },
  // when route changes and this component is already rendered,
  // the logic will be slightly different.
  beforeRouteUpdate (to, from, next) {
    next(vm => {
      const foundPage = store.getters.pages.find(page => {
        return '/' + page.slug.current === to.path
      })

      if (foundPage) {
        vm.$store.commit('setActivePage', foundPage)
        vm.$store.commit('setActiveChallengePage', foundPage)
      }
    })
  },
  methods: {
    checkout () {
      if (this.user) {
        this.$root.$emit('bv::show::modal', 'modal-challenge-purchase')
      } else {
        this.$root.$emit('bv::show::modal', 'modal-signup')
      }
    }
  }
}
</script>

<style lang='scss'>
</style>
